export const content = {
  en: {
    nav: {
      home: 'Happy Ending',
      erotic: 'Erotic Massage',
      nuru: 'Nuru Massage',
      contact: 'Contact',
      book: 'Book Now',
      lang: 'EN',
    },
    home: {
      meta: {
        title: 'Happy Ending Massage Sukhumvit | Bunny Boy Massage Bangkok',
        description: 'Experience the best happy ending massage in Sukhumvit, Bangkok. Bunny Boy Massage offers premium sensual massage services with beautiful Thai masseuses. Visit us today.',
        keywords: 'happy ending massage sukhumvit, happy ending massage bangkok, sensual massage sukhumvit, massage sukhumvit, bangkok massage, bunny boy massage',
      },
      hero: {
        title: 'Happy Ending Massage',
        subtitle: 'Sukhumvit, Bangkok',
        tagline: 'Where Pleasure Meets Luxury',
        cta: 'Book Your Session',
      },
      about: {
        title: 'Welcome to Bunny Boy Massage',
        subtitle: 'The Premier Happy Ending Massage Experience in Sukhumvit',
        description: 'Nestled in the heart of Sukhumvit, Bangkok, Bunny Boy Massage offers an unparalleled sensual massage experience. Our skilled masseuses combine traditional Thai massage techniques with intimate, personalized attention to create moments of pure bliss.',
        description2: 'Step into our luxurious private rooms, designed to transport you to a world of relaxation and pleasure. Every detail has been carefully curated to ensure your complete satisfaction.',
      },
      services: {
        title: 'Our Signature Services',
        subtitle: 'Tailored Experiences for Your Pleasure',
        items: [
          {
            title: 'Standard Room',
            duration: '90 min',
            price: 'THB 2,500',
            description: 'Body Scrub, Aromatherapy Massage, and Kassai Massage in our comfortable standard private room.',
          },
          {
            title: 'Luxury Room',
            duration: '60 min',
            price: 'THB 2,700',
            description: 'Spa Hot Tub Onsen, Aromatherapy Massage, and Kassai Massage in our premium luxury suite.',
          },
          {
            title: 'Luxury Room',
            duration: '90 min',
            price: 'THB 3,200',
            description: 'Spa Hot Tub Onsen, Body Scrub, Aromatherapy Massage, and Kassai Massage — the ultimate luxury experience.',
          },
        ],
      },
      why: {
        title: 'Why Choose Bunny Boy Massage?',
        items: [
          { title: 'Excellent Accessibility', desc: '5-min walk from Phra Khanong BTS Station' },
          { title: 'Top Model Lineup', desc: 'Largest selection of masseuses in their 20s' },
          { title: 'Customer Satisfaction First', desc: 'The best service mindset for your pleasure' },
          { title: 'Reasonable Prices', desc: 'Payment in Baht, Won, and Dollar accepted' },
        ],
      },
      cta: {
        title: 'Ready for an Unforgettable Experience?',
        subtitle: 'Book your happy ending massage session today',
        button: 'Contact Us Now',
        phone: 'Call: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    erotic: {
      meta: {
        title: 'Erotic Massage Sukhumvit | Best Sensual Massage Bangkok | Bunny Boy Massage',
        description: 'Experience the best erotic massage in Sukhumvit, Bangkok. Bunny Boy Massage offers premium sensual massage with Body Scrub, Spa Hot Tub, Aromatherapy, and Kassai Massage. Near BTS Phra Khanong. Book via LINE or WhatsApp. Open 10AM-midnight daily.',
        keywords: 'erotic massage sukhumvit, erotic massage bangkok, sensual massage sukhumvit, erotic massage near me, best erotic massage bangkok, sukhumvit massage parlor, body massage sukhumvit bangkok, bunny boy massage erotic, erotic thai massage sukhumvit',
      },
      hero: {
        title: 'Erotic Massage',
        subtitle: 'Sukhumvit, Bangkok',
        tagline: 'Surrender to Sensual Bliss',
        cta: 'Experience Now',
      },
      about: {
        title: 'The Complete Guide to Erotic Massage in Sukhumvit',
        subtitle: 'Everything You Need to Know',
        description: 'Looking for the ultimate erotic massage in Sukhumvit? Bunny Boy Massage is Bangkok\'s premier destination for sensual massage experiences. Our expert Thai masseuses combine traditional massage techniques with intimate, personalized attention to awaken every nerve ending in your body. Services include Body Scrub, Spa Hot Tub, Aromatherapy Massage, and Kassai Massage. Located just 5 minutes from BTS Phra Khanong Station, we offer the most accessible luxury erotic massage Sukhumvit has to offer.',
        description2: 'Every erotic massage Sukhumvit session at Bunny Boy Massage is performed in a completely private, sanitized room with premium aromatic oils and mood lighting. Whether you are a first-time visitor or a returning guest, our masseuses tailor each session to your preferences, ensuring an unforgettable experience that goes beyond ordinary massage.',
      },
      services: {
        title: 'Erotic Massage Sukhumvit Packages',
        subtitle: 'Choose Your Perfect Experience',
        items: [
          {
            title: 'Standard Room',
            duration: '60 min',
            price: 'THB 2,000',
            description: 'Aromatherapy Massage and Kassai Massage in our comfortable standard private room. The perfect erotic massage Sukhumvit introduction.',
          },
          {
            title: 'Standard Room',
            duration: '90 min',
            price: 'THB 2,500',
            description: 'Body Scrub, Aromatherapy Massage, and Kassai Massage. Our most recommended erotic massage Sukhumvit course for first-time visitors.',
          },
          {
            title: 'Luxury Room',
            duration: '90 min',
            price: 'THB 3,200',
            description: 'Spa Hot Tub Onsen, Body Scrub, Aromatherapy Massage, and Kassai Massage — the ultimate luxury erotic massage experience in Sukhumvit.',
          },
        ],
      },
      why: {
        title: 'The Bunny Boy Erotic Difference',
        items: [
          { title: 'Excellent Accessibility', desc: '5-min walk from Phra Khanong BTS Station' },
          { title: 'Top Model Lineup', desc: 'Largest selection of masseuses in their 20s' },
          { title: 'Customer Satisfaction First', desc: 'The best service mindset for your pleasure' },
          { title: 'Reasonable Prices', desc: 'Payment in Baht, Won, and Dollar accepted' },
        ],
      },
      cta: {
        title: 'Awaken Your Senses Tonight',
        subtitle: 'Book your erotic massage experience',
        button: 'Reserve Now',
        phone: 'Call: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    nuru: {
      meta: {
        title: 'Nuru Massage Sukhumvit | #1 Premium Massage Bangkok — Bunny Boy Massage',
        description: 'Experience the best Nuru massage in Sukhumvit, Bangkok. Premium Body Scrub, Spa Hot Tub, Aromatherapy, and Kassai Massage by trained masseuses. 5 min from BTS Phra Khanong. Book via LINE/WhatsApp. Open 10AM-midnight.',
        keywords: 'nuru massage sukhumvit, nuru massage bangkok, nuru massage near me, best nuru massage sukhumvit, bunny boy massage nuru, massage sukhumvit bangkok, nuru massage near bts phra khanong',
      },
      hero: {
        title: 'Nuru Massage',
        subtitle: 'Sukhumvit, Bangkok',
        tagline: 'The Ultimate Sensual Massage Experience',
        cta: 'Try Nuru Now',
      },
      about: {
        title: 'Authentic Nuru Massage',
        subtitle: 'Japan\'s Most Sensual Massage Art',
        description: 'At Bunny Boy Massage, our Nuru massage Sukhumvit service offers a premium sensual experience featuring Body Scrub, Spa Hot Tub Onsen (whirlpool bath), Aromatherapy Massage, and Kassai Massage. Each session is tailored to your preferences for ultimate relaxation and pleasure.',
        description2: 'Our masseuses are specially trained professionals who deliver personalized attention in fully private luxury rooms. From the moment you arrive to the final moment of bliss, every detail is designed for your complete satisfaction. An experience you won\'t find anywhere else in Bangkok.',
      },
      services: {
        title: 'Nuru Massage Packages',
        subtitle: 'Choose Your Perfect Session',
        items: [
          {
            title: 'Standard Room',
            duration: '60 min',
            price: 'THB 2,000',
            description: 'Aromatherapy Massage and Kassai Massage in our comfortable standard private room.',
          },
          {
            title: 'Standard Room',
            duration: '90 min',
            price: 'THB 2,500',
            description: 'Body Scrub, Aromatherapy Massage, and Kassai Massage. Our most recommended course for first-time visitors.',
          },
          {
            title: 'Luxury Room',
            duration: '90 min',
            price: 'THB 3,200',
            description: 'Spa Hot Tub Onsen, Body Scrub, Aromatherapy Massage, and Kassai Massage — the ultimate luxury experience.',
          },
        ],
      },
      why: {
        title: 'Why Our Nuru Massage is the Best',
        items: [
          { title: 'Excellent Accessibility', desc: '5-min walk from Phra Khanong BTS Station' },
          { title: 'Top Model Lineup', desc: 'Largest selection of masseuses in their 20s' },
          { title: 'Customer Satisfaction First', desc: 'The best service mindset for your pleasure' },
          { title: 'Reasonable Prices', desc: 'Payment in Baht, Won, and Dollar accepted' },
        ],
      },
      cta: {
        title: 'Slide Into Ecstasy',
        subtitle: 'Book your Nuru massage experience today',
        button: 'Book Nuru Now',
        phone: 'Call: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    footer: {
      brand: 'Bunny Boy Massage',
      tagline: 'Premium Massage Experience in Sukhumvit, Bangkok',
      hours: 'Open Daily: 10:00 AM - 00:00 AM',
      location: 'Sukhumvit 71 Rd, Phra Khanong Nuea, Bangkok',
      copyright: '2025 Bunny Boy Massage. All Rights Reserved.',
      links: {
        title: 'Our Services',
      },
    },
  },
  zh: {
    nav: {
      home: '曼谷情色按摩',
      erotic: '曼谷抓龙筋',
      nuru: '曼谷变相按摩',
      contact: '联系我们',
      book: '立即预约',
      lang: '中文',
    },
    home: {
      meta: {
        title: '曼谷情色按摩 | 素坤逸最佳情色按摩体验 — Bunny Boy Massage',
        description: '体验曼谷情色按摩首选地 Bunny Boy Massage。素坤逸最优质的感官按摩服务，美丽泰国按摩师，BTS Phra Khanong站步行5分钟。LINE/WhatsApp预约。每天10AM-午夜营业。',
        keywords: '曼谷情色按摩, 曼谷情色按摩推荐, 素坤逸情色按摩, 曼谷按摩, 感官按摩曼谷, 泰国情色按摩, 曼谷情色按摩价格, 曼谷情色按摩预约, bunny boy massage, 素坤逸按摩',
      },
      hero: {
        title: '曼谷情色按摩',
        subtitle: '素坤逸，曼谷',
        tagline: '曼谷情色按摩 · 快乐与奢华的交汇',
        cta: '预约您的体验',
      },
      about: {
        title: '欢迎来到 Bunny Boy Massage',
        subtitle: '曼谷情色按摩 · 素坤逸顶级感官体验',
        description: 'Bunny Boy Massage 坐落在曼谷素坤逸的心脏地带，是曼谷情色按摩的首选目的地。我们熟练的按摩师将传统泰式按摩技术与私密、个性化的关注相结合，为每一位客人打造纯粹的感官幸福时刻。作为曼谷情色按摩领域的领军者，我们致力于提供超越期待的奢华体验。',
        description2: '走进我们豪华的私人房间，将您带入一个放松和快乐的世界。从温暖的共浴到精致的全身按摩，每一个细节都经过精心策划，确保您在Bunny Boy Massage获得曼谷最好的情色按摩体验。',
      },
      services: {
        title: '我们的招牌服务',
        subtitle: '为您的快乐量身定制',
        items: [
          { title: '标准房间', duration: '60 分钟', price: 'THB 2,000', description: '芳香精油按摩和卡赛按摩，在舒适的标准私人房间中享受曼谷情色按摩体验。' },
          { title: '标准房间', duration: '90 分钟', price: 'THB 2,500', description: '身体磨砂、芳香精油按摩和卡赛按摩。最推荐的曼谷情色按摩入门套餐。' },
          { title: '豪华房间', duration: '90 分钟', price: 'THB 3,200', description: '温泉浴、身体磨砂、芳香精油按摩和卡赛按摩 — 终极奢华曼谷情色按摩体验。' },
        ],
      },
      why: {
        title: '为什么选择 Bunny Boy Massage？',
        items: [
          { title: '卓越的交通便利', desc: '距Phra Khanong BTS站步行5分钟' },
          { title: '顶级模特阵容', desc: '最多20代按摩师供您选择' },
          { title: '客户满意第一', desc: '以最优质的服务理念为您服务' },
          { title: '合理的价格', desc: '接受泰铢、人民币、美元支付' },
        ],
      },
      cta: {
        title: '准备好迎接难忘的体验了吗？',
        subtitle: '立即预约您的曼谷情色按摩体验',
        button: '立即联系我们',
        phone: '电话: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    erotic: {
      meta: {
        title: '曼谷抓龙筋 | 素坤逸最佳抓龙筋按摩体验 — Bunny Boy Massage',
        description: '体验曼谷抓龙筋首选地 Bunny Boy Massage。素坤逸正宗泰式抓龙筋按摩，专业美丽泰国按摩师，BTS Phra Khanong站步行5分钟。LINE/WhatsApp预约。每天10AM-午夜营业。',
        keywords: '曼谷抓龙筋, 曼谷抓龙筋推荐, 素坤逸抓龙筋, 泰国抓龙筋, 曼谷抓龙筋价格, 曼谷抓龙筋预约, 抓龙筋按摩曼谷, 曼谷正宗抓龙筋, bunny boy massage, 素坤逸按摩',
      },
      hero: {
        title: '曼谷抓龙筋',
        subtitle: '素坤逸，曼谷',
        tagline: '曼谷抓龙筋 · 正宗泰式感官极致体验',
        cta: '立即体验',
      },
      about: {
        title: '曼谷抓龙筋完全指南',
        subtitle: '曼谷抓龙筋 · 您需要知道的一切',
        description: '寻找最正宗的曼谷抓龙筋体验？Bunny Boy Massage 是曼谷素坤逸首选的抓龙筋按摩目的地。我们专业的泰国按摩师将古老的泰式抓龙筋传统与现代亲密按摩技巧完美融合，通过专业的经络穴位手法唤醒您身体的每一个神经末梢。距BTS Phra Khanong站仅5分钟步行，我们提供素坤逸最便捷的曼谷抓龙筋奢华体验。',
        description2: '在 Bunny Boy Massage 的每一次曼谷抓龙筋都在完全私密、消毒的房间中进行，配有高级芳香精油和氛围灯光。无论您是首次体验抓龙筋还是经验丰富的回头客，我们的按摩师都会根据您的喜好量身定制每次曼谷抓龙筋体验，确保超越普通按摩店的难忘经历。',
      },
      services: {
        title: '曼谷抓龙筋体验套餐',
        subtitle: '选择您的曼谷抓龙筋体验',
        items: [
          { title: '标准房间', duration: '60 分钟', price: 'THB 2,000', description: '芳香精油按摩和卡赛按摩，在舒适的标准私人房间中享受曼谷抓龙筋体验。' },
          { title: '标准房间', duration: '90 分钟', price: 'THB 2,500', description: '身体磨砂、芳香精油按摩和卡赛按摩。最推荐的曼谷抓龙筋入门套餐。' },
          { title: '豪华房间', duration: '90 分钟', price: 'THB 3,200', description: '温泉浴、身体磨砂、芳香精油按摩和卡赛按摩 — 终极奢华曼谷抓龙筋体验。' },
        ],
      },
      why: {
        title: '为什么选择 Bunny Boy 曼谷抓龙筋',
        items: [
          { title: '卓越的交通便利', desc: '距Phra Khanong BTS站步行5分钟，曼谷抓龙筋最便捷的位置' },
          { title: '顶级模特阵容', desc: '最多20代美丽按摩师供您选择体验曼谷抓龙筋' },
          { title: '客户满意第一', desc: '以最优质的曼谷抓龙筋服务理念为您服务' },
          { title: '合理的价格', desc: '曼谷抓龙筋透明定价，接受泰铢、人民币、美元支付' },
        ],
      },
      cta: {
        title: '准备好体验最正宗的曼谷抓龙筋了吗？',
        subtitle: '立即预约您的曼谷抓龙筋体验',
        button: '立即预约曼谷抓龙筋',
        phone: '电话: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    nuru: {
      meta: {
        title: '曼谷变相按摩 | 素坤逸最佳变相按摩体验 — Bunny Boy Massage',
        description: '体验素坤逸最好的曼谷变相按摩。身体磨砂、温泉浴、芳香精油按摩、卡赛按摩，专业训练按摩师，私密高端环境。距BTS Phra Khanong站5分钟。LINE/WhatsApp预约曼谷变相按摩。',
        keywords: '曼谷变相按摩, 素坤逸变相按摩, 曼谷nuru按摩, 素坤逸nuru按摩, 曼谷日式按摩, 泰国变相按摩, bunny boy massage nuru',
      },
      hero: {
        title: '曼谷变相按摩',
        subtitle: '素坤逸，曼谷',
        tagline: '曼谷变相按摩 · 终极感官按摩体验',
        cta: '立即体验',
      },
      about: {
        title: '曼谷变相按摩',
        subtitle: '日本最具感官的按摩艺术 · 曼谷变相按摩',
        description: '在Bunny Boy Massage，曼谷变相按摩服务包含身体磨砂、温泉浴（按摩浴缸）、芳香精油按摩和卡赛按摩。每一次曼谷变相按摩都根据您的个人偏好量身定制，确保终极放松与感官享受。',
        description2: '我们的按摩师都是经过严格专业培训的专业人员，在完全私密的豪华房间中提供个性化的贴心服务。从您到达的那一刻到幸福的最后一刻，每一个细节都为您的完全满意而精心设计。打造您在曼谷其他任何地方都找不到的独特曼谷变相按摩体验。',
      },
      services: {
        title: '曼谷变相按摩套餐',
        subtitle: '选择您的曼谷变相按摩体验',
        items: [
          { title: '标准房间', duration: '60 分钟', price: 'THB 2,000', description: '芳香精油按摩和卡赛按摩，在舒适的标准私人房间中享受曼谷变相按摩体验。' },
          { title: '标准房间', duration: '90 分钟', price: 'THB 2,500', description: '身体磨砂、芳香精油按摩和卡赛按摩。最推荐的曼谷变相按摩入门套餐。' },
          { title: '豪华房间', duration: '90 分钟', price: 'THB 3,200', description: '温泉浴、身体磨砂、芳香精油按摩和卡赛按摩 — 终极奢华曼谷变相按摩体验。' },
        ],
      },
      why: {
        title: '为什么选择我们的曼谷变相按摩',
        items: [
          { title: '素坤逸黄金位置', desc: '距Phra Khanong BTS站步行5分钟，曼谷变相按摩最便捷的选择' },
          { title: '顶级按摩师阵容', desc: '经过专业曼谷变相按摩培训的20代美丽按摩师' },
          { title: '客户满意第一', desc: '以最优质的曼谷变相按摩服务理念为您服务' },
          { title: '完全私密环境', desc: '4楼独立房间，为您的曼谷变相按摩体验提供最大隐私保障' },
        ],
      },
      cta: {
        title: '体验最好的曼谷变相按摩',
        subtitle: '立即预约您的曼谷变相按摩，开启素坤逸最正宗的日式感官之旅',
        button: '立即预约曼谷变相按摩',
        phone: '电话: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    footer: {
      brand: 'Bunny Boy Massage',
      tagline: '素坤逸曼谷高级按摩体验',
      hours: '每日营业: 12:00 PM - 3:00 AM',
      location: '素坤逸路，曼谷，泰国',
      copyright: '2025 Bunny Boy Massage. 版权所有。',
      links: { title: '我们的服务' },
    },
  },
  ko: {
    nav: {
      home: '방콕 변마',
      erotic: '방콕 전립선마사지',
      nuru: '방콕 짭까사이',
      contact: '문의하기',
      book: '지금 예약',
      lang: '한국어',
    },
    home: {
      meta: {
        title: '방콕 변마 | 수쿰빗 최고의 프리미엄 변마 체험 — Bunny Boy Massage',
        description: '방콕 변마 최고의 선택 Bunny Boy Massage. 수쿰빗 프리미엄 방콕 변마, 20대 전문 마사지사, 프라이빗 룸, BTS 프라카농역 도보 5분. LINE/WhatsApp으로 방콕 변마 예약하세요.',
        keywords: '방콕 변마, 수쿰빗 변마, 방콕 변마 추천, 방콕 변마 가격, 방콕 마사지, 수쿰빗 마사지, 방콕 변마 후기, 태국 변마, 방콕 에로틱 마사지, bunny boy massage',
      },
      hero: {
        title: '방콕 변마',
        subtitle: '수쿰빗, 방콕',
        tagline: '방콕 변마 · 최고의 프리미엄 감각 체험',
        cta: '지금 예약하기',
      },
      about: {
        title: '방콕 변마 No.1 · Bunny Boy Massage',
        subtitle: '수쿰빗 최고의 방콕 변마 체험',
        description: '방콕 수쿰빗의 중심에 위치한 Bunny Boy Massage는 방콕 변마의 새로운 기준을 제시합니다. 엄선된 20대 전문 마사지사들이 전통 태국 마사지 기법과 프리미엄 감각 테크닉을 결합하여, 다른 어떤 곳에서도 경험할 수 없는 최고급 방콕 변마 서비스를 제공합니다.',
        description2: '럭셔리한 프라이빗 룸에 들어서는 순간, 방콕 변마의 진정한 의미를 깨닫게 됩니다. 모든 디테일이 완벽한 만족을 위해 세심하게 준비된 Bunny Boy Massage의 방콕 변마 체험을 경험해보세요.',
      },
      services: {
        title: '방콕 변마 시그니처 서비스',
        subtitle: '나에게 맞는 방콕 변마 체험 선택',
        items: [
          { title: '스탠다드 룸', duration: '60분', price: 'THB 2,000', description: '아로마테라피 마사지와 카사이 마사지. 편안한 스탠다드 프라이빗 룸에서 진행되는 방콕 변마 체험.' },
          { title: '스탠다드 룸', duration: '90분', price: 'THB 2,500', description: '바디스크럽, 아로마테라피 마사지, 카사이 마사지. 가장 추천하는 방콕 변마 코스입니다.' },
          { title: '럭셔리 룸', duration: '90분', price: 'THB 3,200', description: '스파 핫터브, 바디스크럽, 아로마테라피 마사지, 카사이 마사지 — 최고의 럭셔리 방콕 변마 체험.' },
        ],
      },
      why: {
        title: '방콕 변마 왜 Bunny Boy Massage인가?',
        items: [
          { title: '수쿰빗 최고 위치', desc: '프라카농역 도보 5분, 방콕 변마 최고의 접근성' },
          { title: '20대 전문 매니저', desc: '엄선된 20대 미녀 마사지사 최다 보유' },
          { title: '최고의 서비스 품질', desc: '방콕 변마 고객만족도 1위 목표' },
          { title: '투명한 합리적 가격', desc: '바트/한화/달러 결제, 추가 비용 없음' },
        ],
      },
      cta: {
        title: '방콕 변마 최고의 체험을 준비하세요',
        subtitle: '지금 Bunny Boy Massage에서 방콕 변마를 예약하세요',
        button: '방콕 변마 예약하기',
        phone: '전화: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    erotic: {
      meta: {
        title: '방콕 전립선마사지 | 수쿰빗 최고의 프리미엄 전립선마사지 체험 — Bunny Boy Massage',
        description: '방콕 전립선마사지 최고의 선택 Bunny Boy Massage. 수쿰빗 프리미엄 방콕 전립선마사지, 20대 전문 마사지사, 프라이빗 룸, BTS 프라카농역 도보 5분. LINE/WhatsApp으로 방콕 전립선마사지 예약하세요.',
        keywords: '방콕 전립선마사지, 수쿰빗 전립선마사지, 방콕 전립선마사지 추천, 방콕 전립선마사지 가격, 방콕 전립선마사지 후기, 태국 전립선마사지, 방콕 바디 마사지, 수쿰빗 마사지, 방콕 에로틱 마사지, bunny boy massage',
      },
      hero: {
        title: '방콕 전립선마사지',
        subtitle: '수쿰빗, 방콕',
        tagline: '방콕 전립선마사지 · 최고의 프리미엄 감각 체험',
        cta: '지금 체험하기',
      },
      about: {
        title: '방콕 전립선마사지 No.1 · Bunny Boy Massage',
        subtitle: '수쿰빗 최고의 방콕 전립선마사지 체험',
        description: '방콕 전립선마사지를 찾고 계신가요? Bunny Boy Massage는 방콕 전립선마사지의 새로운 기준을 제시합니다. 바디스크럽, 스파 핫터브(월풀 욕조), 아로마테라피 마사지, 카사이 마사지로 구성된 프리미엄 서비스를 엄선된 20대 전문 마사지사들이 제공합니다. BTS 프라카농역에서 도보 5분 거리에 위치한 수쿰빗 최고의 방콕 전립선마사지를 만나보세요.',
        description2: 'Bunny Boy Massage의 모든 방콕 전립선마사지 세션은 완전한 프라이빗 살균 룸에서 프리미엄 아로마 오일과 무드 조명과 함께 진행됩니다. 첫 방문이든 재방문이든, 방콕 전립선마사지 마사지사가 고객의 취향에 맞춰 맞춤형 세션을 제공하여 일반 마사지를 초월하는 잊지 못할 방콕 전립선마사지 경험을 보장합니다.',
      },
      services: {
        title: '방콕 전립선마사지 시그니처 서비스',
        subtitle: '나에게 맞는 방콕 전립선마사지 코스 선택',
        items: [
          { title: '스탠다드 룸', duration: '60분', price: 'THB 2,000', description: '아로마테라피 마사지와 카사이 마사지. 편안한 스탠다드 프라이빗 룸에서 진행되는 방콕 전립선마사지 체험.' },
          { title: '스탠다드 룸', duration: '90분', price: 'THB 2,500', description: '바디스크럽, 아로마테라피 마사지, 카사이 마사지. 가장 추천하는 방콕 전립선마사지 코스입니다.' },
          { title: '럭셔리 룸', duration: '90분', price: 'THB 3,200', description: '스파 핫터브, 바디스크럽, 아로마테라피 마사지, 카사이 마사지 — 최고의 럭셔리 방콕 전립선마사지 체험.' },
        ],
      },
      why: {
        title: '방콕 전립선마사지 왜 Bunny Boy Massage인가?',
        items: [
          { title: '수쿰빗 최고 위치', desc: '프라카농역 도보 5분, 방콕 전립선마사지 최고의 접근성' },
          { title: '20대 전문 매니저', desc: '엄선된 20대 미녀 마사지사 최다 보유' },
          { title: '최고의 서비스 품질', desc: '방콕 전립선마사지 고객만족도 1위 목표' },
          { title: '투명한 합리적 가격', desc: '바트/한화/달러 결제, 추가 비용 없음' },
        ],
      },
      cta: {
        title: '방콕 전립선마사지 최고의 체험을 준비하세요',
        subtitle: '지금 Bunny Boy Massage에서 방콕 전립선마사지를 예약하세요',
        button: '방콕 전립선마사지 예약하기',
        phone: '전화: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    nuru: {
      meta: {
        title: '방콕 짭까사이 | 수쿰빗 최고의 정통 방콕 짭까사이 체험 — Bunny Boy Massage',
        description: '방콕 짭까사이 최고의 선택 Bunny Boy Massage. 바디스크럽, 스파 핫터브, 아로마테라피 마사지, 카사이 마사지, 20대 전문 마사지사, 프라이빗 룸. BTS 프라카농역 도보 5분. LINE/WhatsApp으로 방콕 짭까사이 예약하세요.',
        keywords: '방콕 짭까사이, 짭까사이 방콕, 방콕 짭까사이 추천, 방콕 짭까사이 가격, 방콕 짭까사이 후기, 수쿰빗 짭까사이, 태국 짭까사이, 방콕 짭까사이 예약, bunny boy massage',
      },
      hero: {
        title: '방콕 짭까사이',
        subtitle: '수쿰빗, 방콕',
        tagline: '방콕 짭까사이 · 궁극의 프리미엄 감각 체험',
        cta: '지금 체험하기',
      },
      about: {
        title: '방콕 짭까사이 No.1 · Bunny Boy Massage',
        subtitle: '수쿰빗 최고의 정통 방콕 짭까사이 체험',
        description: '방콕 짭까사이를 찾고 계신가요? Bunny Boy Massage는 방콕 수쿰빗에서 최고의 방콕 짭까사이 체험을 제공합니다. 바디스크럽, 스파 핫터브(월풀 욕조), 아로마테라피 마사지, 카사이 마사지로 구성된 프리미엄 서비스를 엄선된 20대 전문 마사지사들이 제공합니다. 다른 어떤 곳에서도 경험할 수 없는 최고급 방콕 짭까사이를 만나보세요.',
        description2: 'Bunny Boy Massage의 모든 방콕 짭까사이 세션은 완전한 프라이빗 룸에서 프리미엄 아로마 오일과 무드 조명과 함께 진행됩니다. 첫 방콕 짭까사이 방문이든 재방문이든, 마사지사가 고객의 취향에 맞춰 맞춤형 방콕 짭까사이 세션을 제공하여 일반 마사지를 초월하는 잊지 못할 방콕 짭까사이 경험을 보장합니다.',
      },
      services: {
        title: '방콕 짭까사이 시그니처 코스',
        subtitle: '나에게 맞는 방콕 짭까사이 코스 선택',
        items: [
          { title: '스탠다드 룸', duration: '60분', price: 'THB 2,000', description: '아로마테라피 마사지와 카사이 마사지. 편안한 스탠다드 프라이빗 룸에서 진행되는 방콕 짭까사이 체험.' },
          { title: '스탠다드 룸', duration: '90분', price: 'THB 2,500', description: '바디스크럽, 아로마테라피 마사지, 카사이 마사지. 가장 추천하는 방콕 짭까사이 코스입니다.' },
          { title: '럭셔리 룸', duration: '90분', price: 'THB 3,200', description: '스파 핫터브, 바디스크럽, 아로마테라피 마사지, 카사이 마사지 — 최고의 럭셔리 방콕 짭까사이 체험.' },
        ],
      },
      why: {
        title: '방콕 짭까사이 왜 Bunny Boy Massage인가?',
        items: [
          { title: '수쿰빗 최고 위치', desc: '프라카농역 도보 5분, 방콕 짭까사이 최고의 접근성' },
          { title: '20대 전문 매니저', desc: '엄선된 20대 미녀 마사지사 최다 보유' },
          { title: '최고의 서비스 품질', desc: '방콕 짭까사이 고객만족도 1위 목표' },
          { title: '투명한 합리적 가격', desc: '방콕 짭까사이 바트/한화/달러 결제, 추가 비용 없음' },
        ],
      },
      cta: {
        title: '최고의 방콕 짭까사이 체험을 준비하세요',
        subtitle: '지금 Bunny Boy Massage에서 방콕 짭까사이를 예약하세요. 매일 10AM-자정 영업.',
        button: '방콕 짭까사이 예약하기',
        phone: '전화: 081-110-3766',
        line: 'LINE: bunnyboybkk (Click)',
        kakao: 'WhatsApp: 081-110-3766',
      },
    },
    footer: {
      brand: 'Bunny Boy Massage',
      tagline: '수쿰빗 방콕 프리미엄 마사지 경험',
      hours: '매일 영업: 오후 12:00 - 오전 3:00',
      location: '수쿰빗 로드, 방콕, 태국',
      copyright: '2025 Bunny Boy Massage. All Rights Reserved.',
      links: { title: '서비스' },
    },
  },
};
